import React from 'react';
import SocialIcons from '@src/components/SocialButtons/SocialIcons';
import {P24_SOCIAL_URLS} from "@src/utils/constants";


const FollowUs = () => (
  <div aria-label="Soziale Medien Links" className="social-button-group" role="group">
    <SocialIcons baseUrls={P24_SOCIAL_URLS} />
  </div>
);

export default FollowUs;
